import AppointmentList from "views-interpreters/AppointmentList";
import Dashboard from "views-interpreters/Dashboard";
import Payments from "views-interpreters/Payments";
import Timesheet from "views-interpreters/Timesheet";
import Profile from "views-interpreters/profile";
import Chat from "views-interpreters/Chat";
import ChangePassword from "views/ChangePassword";


import Translation from "views-interpreters/Translations/Translation";
import TranslationView from "views-interpreters/Translations/TranslationView";

var routesInterpreters = [
  {
    path: "/dashboard",
    title:"Dashboard",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Dashboard />,
    layout: "/interpreter",
  },
  {
    path: "/appointments",
    title:"Appointments",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <AppointmentList />,
    layout: "/interpreter",
  },
    {
    path: "/translation",
    title:"Translations",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Translation />,
    layout: "/interpreter",
  },
  {
    path: "/translation/view/:id",
    subRoute: true,
    component: <TranslationView />,
    layout: "/interpreter",
  },
  {
    path: "/payments",
    title: "Payments",
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component:  <Payments/>,
    layout: "/interpreter",
  },
  {
    path: "/Timesheet",
    title: "Timesheet",
    icon: "/images/calendar-days-regular-full.svg",
    iconActive: "/images/calendar-days-solid-full.svg",
    component:  <Timesheet/>,
    layout: "/interpreter",
  },
  {
    path: "/profile",
    subRoute: true,
    component:  <Profile/>,
    layout: "/interpreter",
  },
  {
    path: "/change-password",
    subRoute: true,
    component: <ChangePassword />,
    layout: "/interpreter",
  },
  // {
  //   path: "chat",
  //   title: "Chat",
  //   icon: "/images/Reports.png",
  //   iconActive: "/images/Reports-fill.png",
  //   component: <Chat />,
  //   layout: "",
  // },
];
export default routesInterpreters;
